import { AuthService, ConfigStateService, EnvironmentService, findRoute, getRoutePath, PermissionService, RoutesService } from '@abp/ng.core';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvService } from '../environments/env.service';



@Injectable({
  providedIn: 'root',
})
export class NhAuthGuard implements CanActivate {

  constructor(
    private router: Router,
    protected environment: EnvironmentService,
    protected Auth:AuthService,
    protected permission:PermissionService,
    protected envService:EnvService,
    private routesService: RoutesService,
     private permissionService: PermissionService,
     private configStateService: ConfigStateService,
    //private httpErrorReporter: HttpErrorReporterService,

  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    var defaultRole = this.envService.DefaultRole;
    var currentUser = this.configStateService.getAll().currentUser;

    if(currentUser.roles.some(function(el) { return el === defaultRole}))
    {
      return of(true);
    }

    if (currentUser.isAuthenticated) {
      return of(true);      
    }
    
    return of(false);
  }

}